<template>
  <div class="flex flex-col gap-4">
    <div class="font-bold">{{ t('uploadImages') }}</div>
    <div v-if="!item?.id" class="flex gap-2">
      <el-upload
          drag
          multiple
          v-model:file-list="files"
          list-type="picture-card"
          :auto-upload="false"
      >
        <template #file="{ file }">
          <div class="w-[148px]"
               :class="{'rounded-sm border-4 border-green-500': selectedFile == file}">
            <img class="el-upload-list__item-thumbnail" :src="file.url"
                 alt=""/>
            <span class="el-upload-list__item-actions">
                <span v-if="selectedFile != file"
                      class="el-upload-list__item-preview">
                 <el-icon @click="() => {selectFile(file)}">
                  <Select/>
                </el-icon>
               </span>
                  <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                  >
                    <el-icon><Delete/></el-icon>
                  </span>
              </span>
          </div>
        </template>
        <div class="m-[17px] text-xl">
          <el-icon>
            <Plus/>
          </el-icon>
        </div>
      </el-upload>
    </div>
    <div v-if="item?.id" class="flex flex-col gap-4">
      <div>
        <div class="gap-2">

          <ul class="flex flex-wrap el-upload-list el-upload-list--picture-card">
            <li :key="i" v-for="(itemImage, i) in item.itemImages"
                class="el-upload-list__item"
                :class="{'is-success': selectedItemImage == itemImage}">
              <div class="w-[148px]"
                   :class="{'rounded-sm border-4 border-green-500': selectedItemImage == itemImage}">
                <img class="el-upload-list__item-thumbnail"
                     :src="settingsStore.storagePath + '/items/' + item.id + '/' + itemImage.filename"
                     alt="">
                <label class="el-upload-list__item-status-label">
                </label>
                <span class="el-upload-list__item-actions">
              <span v-if="selectedItemImage != itemImage"
                    class="el-upload-list__item-preview">
                 <el-icon @click="() => {selectItemImage(itemImage, true)}">
                  <Select/>
                </el-icon>
               </span>
              <span class="el-upload-list__item-delete">
                 <el-icon @click="() => {handleRemoveOnRemote(itemImage)}">
                  <Delete/>
                </el-icon>
              </span>
            </span>
              </div>

            </li>
            <li>
              <el-upload
                  class="w-[146px] h-[147px]"
                  drag
                  multiple
                  :show-file-list="false"
                  :action="`${Item.ENDPOINT}/${item?.id}/images`"
                  :on-success="onSuccess"
                  :on-error="showError"
                  :http-request="handleUpload"
              >
                <div class="m-[17px] text-xl">
                  <el-icon>
                    <Plus/>
                  </el-icon>
                </div>
              </el-upload>
            </li>
          </ul>

        </div>

      </div>
    </div>

  </div>
</template>
<script setup lang="ts">
import {useHTTP} from "@/plugins/http";
import {defineEmits, onMounted, ref} from "vue";
import {Delete, Plus, Select} from '@element-plus/icons-vue'
import type {
  UploadFile,
  UploadFiles,
  UploadRequestOptions,
  UploadUserFile
} from 'element-plus'
import {ElMessage} from 'element-plus'
import {useI18n} from "vue-i18n";
import {useSettingsStore} from "@/stores/settingsStore";
import {watch} from "vue-demi";
import Item from "@/models/inventory/Item";
import ItemImage from "@/models/inventory/ItemImage";

const props = defineProps(['modelValue', 'data'])
const emit = defineEmits(['update:modelValue'])

const {t} = useI18n({
  messages: {
    en: {
      uploadImages: 'Upload Images',
    },
    ar: {
      uploadImages: 'رفع صور',
    }
  }
})


const http = useHTTP()

const selectedFile = ref<UploadUserFile | null>();
const selectedItemImage = ref<ItemImage | null>();

const files = ref<Array<UploadUserFile>>([]);
const settingsStore = useSettingsStore();

const item = ref<Item>();

onMounted(() => {
  item.value = props.data as Item
  item.value?.itemImages.forEach(i => {
    if (i.isDefault) {
      selectedItemImage.value = i;
    }
  })
})


watch(() => files, (newValue) => {
  emit('update:modelValue', newValue.value.map(v => ({
    isDefault: selectedFile.value != null,
    data: v
  })))
}, {deep: true})


function handleRemove(uploadFile: UploadUserFile) {
  files.value = files.value.filter(f => f.uid != uploadFile.uid)
}

function handleRemoveOnRemote(uploadFile: any) {
  http.delete(`${Item.ENDPOINT}/images/${uploadFile.id}`).then(resp => {
    onSuccess();
  })
}


function handleUpload(options: UploadRequestOptions) {
  const data = new FormData();
  data.set('image', options.file)
  return http.put(options.action, data)
}

function selectFile(file: any) {
  selectedFile.value = file;
  emit('update:modelValue', files.value.map(file => ({
    isDefault: selectedFile.value == file,
    data: file
  })))
}

function selectItemImage(itemImage: ItemImage) {
  http.put(`${Item.ENDPOINT}/images/${itemImage.id}/mark-as-default`).then(data => {
    selectedItemImage.value = itemImage;
    onSuccess();
  }).catch(e => {
    console.log(e)
  })
}

function showError(error: any, uploadFile: UploadFile, uploadFiles: UploadFiles) {
  ElMessage({
    showClose: true,
    message: error?.title,
    type: 'error',
  })
}

async function onSuccess() {
  item.value = await http.get<Item>(Item.ENDPOINT + `/${item.value.id}`);
  item.value?.itemImages.forEach(i => {
    if (i.isDefault) {
      selectedItemImage.value = i;
    }
  })
}

</script>
<style scoped>

</style>
